import t from '../../translate'
import Field from "../../components/Field";
import React from 'react'

export default function Academic ({ program}) {
  const {
    academicQualificationRequired
  } = program.qualification || {};
  return <>
    {academicQualificationRequired && <p>{t('data.studies.academic.label')}*</p>}
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className="form-checkbox">
          <Field
            id={'data.studies.academic.bachelor.has'}
            name="data.studies.academic.bachelor.has"
            type="checkbox"
          />
          <label
            htmlFor={'data.studies.academic.bachelor.has'}
            className="form-radio-label">
            {t(
              'data.studies.academic.bachelor')}
          </label>
        </div>
      </div>
      <div className={'form-col'}>
        <label
          htmlFor={'data.studies.academic.bachelor.degree'}>{t(
          'data.studies.academic.degree')}</label>
        <Field type={'text'} id={'data.studies.academic.bachelor.degree'}
               name={'data.studies.academic.bachelor.degree'}/>
      </div>
    </div>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className="form-checkbox">
          <Field
            id={'data.studies.academic.diploma.has'}
            name="data.studies.academic.diploma.has"
            type="checkbox"
          />
          <label
            htmlFor={'data.studies.academic.diploma.has'}
            className="form-radio-label">
            {t(
              'data.studies.academic.diploma')}
          </label>
        </div>
      </div>
      <div className={'form-col'}>
        <label
          htmlFor={'data.studies.academic.diploma.degree'}>{t(
          'data.studies.academic.degree')}</label>
        <Field type={'text'} id={'data.studies.academic.diploma.degree'}
               name={'data.studies.academic.diploma.degree'}/>
      </div>
    </div>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className="form-checkbox">
          <Field
            id={'data.studies.academic.master.has'}
            name="data.studies.academic.master.has"
            type="checkbox"
          />
          <label
            htmlFor={'data.studies.academic.master.has'}
            className="form-radio-label">
            {t(
              'data.studies.academic.master')}
          </label>
        </div>
      </div>
      <div className={'form-col'}>
        <label
          htmlFor={'data.studies.academic.master.degree'}>{t(
          'data.studies.academic.degree')}</label>
        <Field type={'text'} id={'data.studies.academic.master.degree'}
               name={'data.studies.academic.master.degree'}/>
      </div>
    </div>
    <div className="form-checkbox">
      <Field
        id={'data.studies.academic.other.has'}
        name="data.studies.academic.other.has"
        type="checkbox"
      />
      <label
        htmlFor={'data.studies.academic.other.has'}
        className="form-radio-label">
        {t(
          'data.studies.academic.other')}
      </label>
    </div>
    <Field type={'text'} id={'data.studies.academic.other.description'} name={'data.studies.academic.other.description'}/>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className={'form-row'}>
          <div className={'form-col'}>
            <label
              htmlFor={'data.studies.academic.date'}
              className="form-radio-label">
              {t(
                'data.studies.academic.date')}
              {academicQualificationRequired && <>*</>}
            </label>
            <Field type="date"
                   id={'data.studies.academic.date'}
                   name={'data.studies.academic.date'}/>
          </div>
          <div className={'form-col'}>
            <label
              htmlFor={'data.studies.academic.averageGrade'}
              className="form-radio-label">
              {t(
                'data.studies.academic.averageGrade')}
              {academicQualificationRequired && <>*</>}
            </label>
            <Field type="text"
                   id={'data.studies.academic.averageGrade'}
                   name={'data.studies.academic.averageGrade'}/>
          </div>
        </div>
      </div>
    </div>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <label
          htmlFor={'data.studies.academic.city'}
          className="form-radio-label">
          {t(
            'data.studies.academic.city')}
          {academicQualificationRequired && <>*</>}
        </label>
        <Field type="text"
               id={'data.studies.academic.city'}
               name={'data.studies.academic.city'}/>
      </div>
      <div className={'form-col'}>
        <label
          htmlFor={'data.studies.academic.county'}
          className="form-radio-label">
          {t(
            'data.studies.academic.county')}
          {academicQualificationRequired && <>*</>}
        </label>
        <Field type="text"
               id={'data.studies.academic.county'}
               name={'data.studies.academic.county'}/>
      </div>
    </div>
  </>
}